export default __webpack_public_path__ + "static/agile-project-management-7db77bf5862bad93c988d3905ec524bf.png";